import "./instrument";
import "./theme_env";
import "./i18n";
import * as Sentry from "@sentry/react";
import React from "react";
import { ErrorPage } from "./components/shared/error_page";
import App from "./App";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Sentry.ErrorBoundary fallback={<ErrorPage/>} showDialog>
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);